import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Textarea,
} from '@/platform/ui';
import { useForm } from '@inertiajs/react';

/**
 * Stops the DGR look-ups until someone resumes them. The reason is stored with
 * the pause and in the audit log.
 */
const PauseModal = ({ onClose }) => {
    const { data, setData, post, errors, processing } = useForm({ reason: '' });

    const submit = () =>
        post('/services/dgr/monitor/pause', {
            preserveScroll: true,
            onSuccess: onClose,
        });

    return (
        <Modal open={true} onClose={onClose}>
            <ModalHeader>DGR-controles pauzeren</ModalHeader>
            <ModalContent>
                <p className='mb-3 text-sm text-gray-500'>
                    Er starten geen nieuwe controles bij UWV. Een controle die
                    al loopt, kan nog afronden. De rest blijft wachten en wordt
                    na hervatten opgepakt.
                </p>
                <Textarea
                    label='Reden'
                    required
                    rows={3}
                    value={data.reason}
                    onChange={event => setData('reason', event.target.value)}
                    error={errors?.reason}
                />
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button variant='primary' loading={processing} onClick={submit}>
                    Pauzeren
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default PauseModal;
